import checkoutFormModel from "./checkoutFormModel";

const {
  formField: { plan },
} = checkoutFormModel;

export default {
  [plan.name]: "",
};
